import React from "react";
import deletion from "../../components/deletion.jpeg";

function PayForDeletion() {
  return (
    <div className="container">
      <div className="banner">
        <img src={deletion} alt="" />
      </div>
      <div className="container_body">
        <div className="course">
          <h1>Pay for Deletion</h1>
          <p>
            Here is a letter template to use for offering a payment for deletion
            to the collection company holding the debt.{" "}
            <a href="https://docs.google.com/document/d/1h7PhucXZKERQQtnQkPqxY09pHRozzt7o/edit?usp=drive_link&ouid=117717385823951033045&rtpof=true&sd=true">
              Pay For Deletion
            </a>
          </p>
        </div>
        {/* <div className="downloads"></div> */}
      </div>
    </div>
  );
}

export default PayForDeletion;
